import { useDashboardApiClient } from '@/api/dashboard/useDashboardApiClient'
import type { Workspace, WorkspaceOverview, WorkspaceType } from './types'

const ENDPOINTS = {
    WORKSPACES: '/workspaces/',
    WORKSPACE_ID: '/workspaces/:workspaceId',
}

type WorkspaceTypeParams = {
    workspaceType: WorkspaceType
}

export const getWorkspaces = () => {
    return useDashboardApiClient<WorkspaceOverview[]>({
        url: ENDPOINTS.WORKSPACES,
    })
}

export type WorkspaceBodyData = {
    name: string
    description?: string
    workspaceType: Uppercase<WorkspaceType>
}

type WorkspaceParams = {
    workspaceId: string
}

export const getWorkspace = (urlParams: WorkspaceParams) => {
    return useDashboardApiClient<Workspace>({
        url: ENDPOINTS.WORKSPACE_ID,
        urlParams,
        method: 'GET',
    })
}

export const postWorkspace = (data: WorkspaceBodyData) => {
    return useDashboardApiClient<WorkspaceOverview>({
        url: ENDPOINTS.WORKSPACES,
        method: 'POST',
        data,
    })
}

export const deleteWorkspace = (params: WorkspaceParams & WorkspaceTypeParams) => {
    return useDashboardApiClient({
        url: ENDPOINTS.WORKSPACE_ID,
        urlParams: {
            workspaceId: params.workspaceId,
        },
        params: {
            workspaceType: params.workspaceType.toUpperCase(),
        },
        method: 'DELETE',
    })
}

export const updateWorkspace = (params: WorkspaceParams, data?: WorkspaceBodyData) => {
    return useDashboardApiClient<WorkspaceOverview>({
        url: ENDPOINTS.WORKSPACE_ID,
        urlParams: {
            workspaceId: params.workspaceId,
        },
        method: 'PATCH',
        data,
    })
}

